import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { clearScope } from '../cache/cachePublicMethods';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.menu_api.items;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));
  // Cached API wrapper for this namespace/group
  const cachedApi = wrapAxiosInstance(api, {
    namespace: 'menu_api',
    group: 'items',
    defaultTtl: '5m',
    hashLargeSegments: true,
    emitMeta: true,
  });



      
  export const getAllItemsByCompanyId = async (company_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllItemsByCompanyId/${company_id}`)
  );
};
  
  // Function to fetch all items by local ID
export const getAllItemsByLocalId = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllItemsByLocalId/${local_id}`)
  );
};

  export const getItemsByLocalIdAndStockControl = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemsByLocalIdAndStockControl/${local_id}`)
  );
};
  
  // Function to fetch items by menu ID
export const getItemsByMenuId = async (menu_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemsByMenuId/${menu_id}`)
  );
};
  
  // Function to fetch items by menu category ID
export const getItemsByMenuCategoryId = async (category_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemsByMenuCategoryId/${category_id}`)
  );
};
  
  // Function to fetch an item by its ID
export const getItemByItemId = async (item_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemByItemId/${item_id}`)
  );
};
  
  // Function to fetch items by filter
export const getItemsByFilter = async (filters: any) => {
  return await retryWithBackoff(() =>
    api.post('/GetItemsByFilter', filters)
  );
};
  
  // Function to create a new item
export const createItem = async (itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateItem', itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};
  
  // Function to update an existing item
export const updateItem = async (item_id: number, itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemById/${item_id}`, itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

  export const updateItemStateById = async (item_id: number, itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemStateById/${item_id}`, itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

  export const updateItemNameById = async (item_id: number, itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemNameById/${item_id}`, itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

  export const updateItemPriceById = async (item_id: number, itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemPriceById/${item_id}`, itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

  export const updateItemLabelById = async (item_id: number, itemData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemLabelById/${item_id}`, itemData)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};
  
  // Function to delete an item by its ID
export const deleteItemById = async (item_id: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteItemById/${item_id}`)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

    export const DeleteItemsSelected = async (items: string[]) => {
  const res = await retryWithBackoff(() =>
    api.delete('/DeleteItemsSelected', {
      data: {
        items_to_delete: items
      }
    })
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};
  
  // Function to add an item to an item combo
export const addItemToItemCombo = async (combo_id: number, item_id: number, quantity: number) => {
  const res = await retryWithBackoff(() =>
    api.post(`/addItemToItemCombo/${combo_id}/${item_id}/${quantity}`, null)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};
  
  // Function to remove an item from a combo
export const removeItemFromCombo = async (combo_item_id: number, item_id: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/RemoveItemFromCombo/${combo_item_id}/${item_id}`)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};
  
  // Function to get all item combos by local ID
export const getAllItemCombosByLocalId = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllItemCombosByLocalId/${local_id}`)
  );
};
  
  // Function to get a combo item by its ID
export const getComboItemById = async (item_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetComboItemById/${item_id}`)
  );
};
  
  // Function to get all item combos by menu ID
export const getAllItemCombosByMenuId = async (menu_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllItemCombosByMenuId/${menu_id}`)
  );
};
  
  // Function to get item combos by menu category ID
export const getItemCombosByMenuCategoryId = async (category_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemCombosByMenuCategoryId/${category_id}`)
  );
};
  
// /UpdateItemIngredients/<int:item_id>

export const updateItemIngredients = async (item_id: number, ingredient_selections: any, ingredient_removals: any) => {
  const res = await retryWithBackoff(() =>
    api.post(`/UpdateItemIngredients/${item_id}`, { ingredient_selections, ingredient_removals })
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
}

export const updateComboItems = async (
  combo_id: number,
  items_to_add: any,
  items_to_remove: any,
) => {
  const res = await retryWithBackoff(() =>
    api.post(`/UpdateComboItems/${combo_id}`, {
      items_to_add,
      items_to_remove,
    })
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};



  export const updateItemCategoryById = async (item_id: number, category_id: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateItemCategoryById/${item_id}`, { category_id })
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'categories' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
}

  /**
   * @ns.route('/GetItemStockStatus/<int:local_id>')
@ns.param('local_id', 'The unique identifier of the local')
class GetItemStockStatus(Resource):
    @ns.doc('get_item_stock_status', security='bearerAuth')
    @jwt_required()
    def get(self, local_id):
        '''
        Analyze stock levels and return shortages and warnings for all items in a local.
        
        PERFORMANCE: Results are cached for 30 seconds to handle high-frequency polling.
        Cache is automatically invalidated when stock changes occur.
        
        Returns a comprehensive stock status report including:
        - shortages: Items with zero stock or missing ingredients
        - warnings: Items with stock at or below minimum quantity threshold
        
        Response format:
        {
            "shortages": {
                "item_id": {
                    "item_name": "Item Name",
                    "missing_ingredients": ["Ingredient 1", "Ingredient 2"] or null for twin ingredients
                }
            },
            "warnings": {
                "item_id": {
                    "item_name": "Item Name",
                    "low_stock_ingredients": ["Ingredient 1", "Ingredient 2"]
                }
            }
        }
        '''
        # Try to get cached result first (30 second cache for high-frequency polling)
        cache_key = f"stock_status_local_{local_id}"
        cached_result = cache.get(cache_key)
        
        if cached_result:
            return cached_result, 200
        
        # Cache miss - compute fresh data
        helper = ItemHelper()
        success, data, status = helper.stockController.get_item_stock_status(local_id)
        
        if not success:
            return data, status
        
        # Cache successful result for 30 seconds
        if status == 200:
            cache.set(cache_key, data, timeout=30)
        
        return data, status
   */

  export const getItemStockStatus = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetItemStockStatus/${local_id}`)
  );
};

// ==========================================
// Third-Party Provider Specific Pricing
// ==========================================

// Get all provider-specific prices for an item
export const getItemThirdPartyPrices = async (item_id: number) => {
  return await retryWithBackoff(() =>
    api.get(`/GetItemThirdPartyPrices/${item_id}`)
  );
};

// Set a provider-specific price for an item
export const setItemThirdPartyPrice = async (item_id: number, third_party_provider_id: number, price: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/SetItemThirdPartyPrice/${item_id}/${third_party_provider_id}`, { price })
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};

// Delete a provider-specific price (falls back to price_delivery)
export const deleteItemThirdPartyPrice = async (item_id: number, third_party_provider_id: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteItemThirdPartyPrice/${item_id}/${third_party_provider_id}`)
  );
  await clearScope({ namespace: 'menu_api', group: 'items' });
  await clearScope({ namespace: 'menu_api', group: 'menus' });
  return res;
};